import {ReactElement} from 'react';
import {Formik} from 'formik';
import {FormikConfig, FormikValues} from 'formik';
import ValidationService from './ValidationService';

const NxFormik = <Values extends FormikValues = FormikValues, ExtraProps = Record<string, unknown>>(props: Omit<FormikConfig<Values>, 'isInitialValid'> & ExtraProps): ReactElement =>
<ValidationService.Provider value={props.validationSchema}>
  <Formik {...props}>
      {props.children}
  </Formik>
</ValidationService.Provider>;

export default NxFormik;
